export default {
      id: "big-speech-usage",
      viewBox: "0 0 186 136",
      url: __webpack_public_path__ + "sprite.svg#big-speech",
      toString: function () {
        return this.url;
      }
    }